import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import useAttioAuthCallback from 'hooks/services/attio/useAttioAuthCallback';
import { useAuth } from 'context/auth';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';
import storeOnboardingError from 'pages/connect/views/storeOnboardingError';

const AttioLoginHandler: FC = () => {
  const { refreshUser } = useAuth();
  const { mutate: attioAuthCallback } = useAttioAuthCallback();

  useOauthCallbackCode({
    provider: 'Attio',
    exchangeCode: attioAuthCallback,
    buildVariables: (code) => ({ code }),
    missingCodePath: PATH.CONNECT,
    successPath: PATH.SETTINGS.INTEGRATIONS.MAIN,
    errorPath: PATH.CONNECT,
    onSuccess: refreshUser,
    onError: (error) => storeOnboardingError(error, IntegrationType.ATTIO),
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default AttioLoginHandler;
